const firebaseConfig = {
    apiKey: "AIzaSyDzpSjjU8tCIdTsjf6_f4Q5xLdnd4WrGXU",
    authDomain: "travel-site-4b05c.firebaseapp.com",
    projectId: "travel-site-4b05c",
    storageBucket: "travel-site-4b05c.appspot.com",
    messagingSenderId: "248165908257",
    appId: "1:248165908257:web:5a1401cfe3b0425fe18860"
  };
  export default firebaseConfig;